import { render, staticRenderFns } from "./CustomDatesTable.vue?vue&type=template&id=2abcef56&scoped=true&"
import script from "./CustomDatesTable.vue?vue&type=script&lang=js&"
export * from "./CustomDatesTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomDatesTable.vue?vue&type=style&index=0&id=2abcef56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abcef56",
  null
  
)

export default component.exports